module.exports = __webpack_public_path__ + "static/img/tag-zhicai@2x.d9ba605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-zhicai@2x.png
// module id = 1626
// module chunks = 0